import Avatar from 'components/base/Avatar';
import { Dropdown, Nav } from 'react-bootstrap';
import avatar57 from 'assets/img/team/40x40/57.webp';
import ProfileDropdownMenu from './ProfileDropdownMenu';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import NotificationDropdownMenu from './NotificationDropdownMenu';
import { useState, useEffect, useRef } from 'react';

import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { selectUnreadCount } from 'store/notificationsSlice';
import { RootState } from 'store';
import CompanySelector from 'components/common/CompanySelector';

const NavItems = () => {
  const unreadCount = useSelector(selectUnreadCount);
  const userRole = useSelector((state: RootState) => state.auth.role);

  // Bell shake animation state
  const [shake, setShake] = useState(false);
  const prevUnreadCount = useRef(unreadCount);

  // Trigger shake animation when unread count increases
  useEffect(() => {
    if (unreadCount > prevUnreadCount.current && unreadCount > 0) {
      setShake(true);
      // Remove shake class after animation completes
      const timer = setTimeout(() => setShake(false), 500);
      return () => clearTimeout(timer);
    }
    prevUnreadCount.current = unreadCount;
  }, [unreadCount]);

  return (
    <div className="navbar-nav navbar-nav-icons flex-row">
      {/* Company Selector for Super Admins */}
      <Nav.Item className="d-flex align-items-center">
        <CompanySelector userRole={userRole || ''} />
      </Nav.Item>

      <Nav.Item>
        <Dropdown className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className={classNames(
              'dropdown-caret-none nav-link h-100 position-relative',
              { 'bell-shake': shake }
            )}
            variant=""
            style={{ marginRight: '10px' }}
          >
            <FeatherIcon icon="bell" size={25} className="text-primary" />

            {/* Phoenix Theme Notification Counter - Improved */}
            {unreadCount > 0 && (
              <span
                className="position-absolute start-100 translate-middle badge rounded-circle bg-danger border border-light border-2 notification-badge"
                style={{
                  fontSize: '0.65rem',
                  top: 10,
                  fontWeight: '700',
                  lineHeight: '1.2',
                  minWidth: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0',
                  transform: 'translate(25%, -25%)'
                }}
              >
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </Dropdown.Toggle>
          <NotificationDropdownMenu />
        </Dropdown>
      </Nav.Item>

      <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link pe-0 py-0 lh-1 h-100 d-flex align-items-center"
            variant=""
          >
            <Avatar src={avatar57} size="l" />
          </Dropdown.Toggle>
          <ProfileDropdownMenu />
        </Dropdown>
      </Nav.Item>
    </div>
  );
};

export default NavItems;
